import { cn } from "../../../utils/class-names";
import { KeyValueList } from "../../key-value-list";
import { asPercent, getProtectedAprMetrics } from "@silo/utils";
import { BreakdownProtected } from "../breakdown/breakdown-protected";
import { Percent, ProtectedAprAsset } from "@silo/types";

export interface PositionProtectedProps {
  className?: string;
  asset: ProtectedAprAsset;
  nativeRewardsSymbol: string;
  revenueApr: Percent;
}

export function PositionProtected({
  className,
  asset,
  nativeRewardsSymbol,
  revenueApr,
}: PositionProtectedProps): JSX.Element {
  const { hasProtectedIncentives, totalProtectedApr, protectedRewards } =
    getProtectedAprMetrics(asset, nativeRewardsSymbol, revenueApr);

  return (
    <div className={cn("flex flex-col", className)}>
      <KeyValueList.Pair>
        <KeyValueList.Key>APR</KeyValueList.Key>

        <KeyValueList.Value
          dataCy="apy"
          className={cn(
            "font-mono font-medium",
            hasProtectedIncentives ? "text-amber-300" : "text-white"
          )}
        >
          {hasProtectedIncentives ? asPercent(totalProtectedApr) : "--"}
        </KeyValueList.Value>
      </KeyValueList.Pair>

      {hasProtectedIncentives && (
        <BreakdownProtected
          className="gap-0 text-sm"
          align="right"
          protectedRewards={protectedRewards}
          revenueApr={revenueApr}
        />
      )}
    </div>
  );
}
